import React, { useContext, useEffect } from 'react';
import CreateProcessContext from 'shared/contexts/CreateProcessContext';
import CandidateCard from 'components/CandidateCard';
import PersonService from 'services/person';
import ProcessService from 'services/process';
import { VisaStatus } from 'API';
import ButtonNav from './ButtonNav';
import Panel from './Panel';
import JobType from '../inputSections/JobType';

const CreateProcessModalPanelDetails: React.FC = () => {
  const {
    process, setProcess, selectedCompany, selectedJob, selectedNational,
    isExistingJob, titleIsTaken,
  } = useContext(CreateProcessContext);

  const company = selectedNational ? selectedNational.company : selectedCompany;

  const canGoExisting = (
    isExistingJob !== null
    && process.slug
    && process.employmentData?.location?.type
    && process.employmentData?.salary?.amount !== null
    && process.employmentData?.startDate
    && process.jobDescriptionID
    && (company?.data?.utilizePremiumProcessingService
      || (process.employmentData?.premiumProcessing !== null))
  );

  const canGoNew = (
    isExistingJob !== null
    && !titleIsTaken
    && process.slug
    && process.employmentData?.location?.type
    && process.employmentData?.salary?.amount !== null
    && process.employmentData?.startDate
    && selectedJob?.title
    && (company?.data?.utilizePremiumProcessingService
      || (process.employmentData?.premiumProcessing !== null))
  );

  const canGoToNext = isExistingJob
    ? canGoExisting
    : canGoNew;

  useEffect(() => {
    // Generate a slug for this process, now that we have
    // name and process type.
    let ignore = false;
    const addSlug = async () => {
      let name = '';
      if (selectedNational) {
        name = PersonService.fullname(selectedNational);
      } else {
        const { firstname, lastname } = process.employeeData || {};
        name = `${firstname} ${lastname}`;
      }

      const slugBase = name + (process.requestedProcess
        ? ` ${process.requestedProcess === VisaStatus.NOT_SURE
          ? ' consultation' : process.requestedProcess}`
        : '');
      const slug = await ProcessService.generateSlug(slugBase);

      if (!ignore) {
        setProcess((draft) => {
          draft.slug = slug;
        });
      }
    };

    addSlug();

    return () => { ignore = true; };
  }, []);

  return (
    <Panel>
      <CandidateCard
        showFileUpload
        showImmigrationStatus
      />

      <JobType
        hideCompany
      />

      <ButtonNav disabled={!canGoToNext} />
    </Panel>
  );
};

export default CreateProcessModalPanelDetails;
